exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ag-header-cell-label{justify-content:center!important}.rangoT1{background-color:#76be7c!important;border:1px solid #62a468}.rangoT1,.rangoT2{color:rgba(65,64,64,.91)}.rangoT2{background-color:#d9ead3!important;border:1px solid #b6dca9}.rangoT3{background-color:#fde8af!important;border:1px solid #f3d583}.rangoT3,.rangoT4{color:rgba(65,64,64,.91)}.rangoT4{background-color:#f5bc95!important;border:1px solid #f6b182}.rangoT5{background-color:#fda0a0!important;border:1px solid #f68585}.rangoT0,.rangoT5{color:rgba(65,64,64,.91)}.rangoT0{background-color:#eceeec;border:1px solid #d4d5d3}.textT1{color:#54a459!important}.textT2{color:#abe59d!important}.textT3{color:#ffe196!important}.textT4{color:#f5bc95!important}.textT5{color:#fda0a0!important}.textT0{color:hsla(0,0%,65%,.94)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-788bad0e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/climan/TableGroups.vue
// module id = 1034
// module chunks = 2